/* ===========================================================================
   Carousel
   =========================================================================== */

import 'slick-carousel/slick/slick.js';

const $carouselHomePage = $('#js-carousel-home');
const $carouselMustHave = $('#js-carousel-mustHave');
const $carouselThemes = $('#js-carousel-themes');
const $carouselSimilarProducts = $('#js-carousel-similarProducts');
const $carouselDressing = $('#js-carousel-dressing');
const $carouselItem = $('#js-carousel-item');
const $loaderProductCarousel = $('#loaderProductCarousel');
const $reinsuranceCarousel = $('#js-carousel-reinsurances');
const $conceptGallery = $('#js-carousel-concept-gallery');

let sliders = [$carouselHomePage, $carouselThemes, $carouselMustHave, $carouselSimilarProducts, $carouselDressing, $carouselItem, $reinsuranceCarousel, $conceptGallery];

// Display Slider with smooth transition when is ready
function changeOpacity(className) {
  var elems = document.querySelectorAll(className);
  var index = 0,
      length = elems.length;

  for ( ; index < length; index++) {
      elems[index].style.transition = "opacity 0.5s linear 0s";
      elems[index].style.opacity = 1;
  }
}

sliders.forEach(function (slider) {
  if (slider !== undefined && slider.length === 1) {
    slider.on('init', function() {
      changeOpacity(slider.selector);
    });
  }
});

if ($carouselHomePage.length) {
    $carouselHomePage.slick(
        {
            fade: true,
            arrows: false,
            autoplay: true,
            dots: true,
            dotsClass: 'carousel-dots',
            appendDots: $('#js-carousel-primary-dots-container')
        }
    );
}

if ($carouselMustHave.length) {
    $carouselMustHave.slick(
        {
            slidesToShow: 4,
            arrows: false,
            infinite: false,
            dots: false,
            settings: 'unslick',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        infinite: true,
                        dots: true,
                        centerMode: true,
                        centerPadding: '90px',
                        dotsClass: 'carousel-dots',
                        appendDots: $('#js-carousel-mustHave-dots-container')
                    }
                }
            ]
        }
    );
}

if ($carouselThemes.length) {
  $carouselThemes.slick(
    {
      slidesToShow: 4,
      arrows: false,
      infinite: false,
      dots: false,
      settings: 'unslick',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: true,
            centerMode: true,
            centerPadding: '90px',
            dotsClass: 'carousel-dots',
            appendDots: $('#js-carousel-themes-dots-container')
          }
        }
      ]
    }
  );
}

if ($carouselSimilarProducts.length) {
  $carouselSimilarProducts.slick(
    {
      slidesToShow: 4,
      arrows: false,
      infinite: false,
      dots: false,
      settings: 'unslick',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: false,
            centerMode: true,
            centerPadding: '59px'
          }
        }
      ]
    }
  );
}

if ($carouselDressing.length) {
  $carouselDressing.slick(
    {
      slidesToShow: 4,
      arrows: false,
      infinite: false,
      dots: false,
      settings: 'unslick',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: false,
            centerMode: true,
            centerPadding: '59px'
          }
        }
      ]
    }
  );
}

if ($carouselItem.length) {
    const firstImgCarousel = $carouselItem.data('load');

    fetch(
        firstImgCarousel,
        {
            credentials: 'include'
            // https://developer.mozilla.org/en-US/docs/Web/API/Request/credentials
        }
    ).then(
        (data) => {
          if (data.status === 200) {
                $carouselItem.slick(
                  {
                    fade: true,
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: 'carousel-dots',
                    appendDots: $('#js-carousel-item-dots-container'),
                    mobileFirst: true,
                    responsive: [
                      {
                        breakpoint: 1024,
                        settings: "unslick"
                      }
                    ]
                  }
                );

                setTimeout(
                () => {
                  $loaderProductCarousel.removeClass('is-loading');
                },
                500
                );
            }
        }
    );
}

if ($reinsuranceCarousel.length) {
  if ($reinsuranceCarousel.children().length > 1) {
    $reinsuranceCarousel.slick(
      {
        arrows: false,
        dots: true,
        dotsClass: 'carousel-dots',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: "unslick"
          }
        ]
      }
    );
  }
}

if ($conceptGallery.length) {
    $conceptGallery.slick({
        // arrows: false,
        dots: false,
        slidesToShow: 3,
        variableWidth: true,
    });
}
